import { GetterTree } from "vuex";
import { State } from "./state";
import { CheckItem, Column, ID, Label, TaskData } from "@/types/task";
import { DayType } from "@/types/calendar";
import DateTime from "@/utils/date";

type getTaskDataType = {
  column: Column | undefined;
  taskId: ID;
};
type getCommentDataType = {
  task: TaskData | undefined;
  commentId: ID;
};
type getDateEventsType = {
  shDay: string;
  hjDay: string;
  mlDay: string;
};

export type Getters = {
  loginDialogStatus(state: State): boolean;
  googleToken(state: State): string | null;
  getUserPicture(state: State): string | null;
  getUserName(state: State): string | null;
  getChecklistStatus(state: State): boolean;
  getCheckList(state: State): CheckItem[];
  getColumns(state: State): Column[];
  getColumn(state: State): (columnId: ID) => Column | undefined;
  getColumnIndex(state: State): (columnId: ID) => number | undefined;
  getTask(): (data: getTaskDataType) => TaskData | undefined;
  getTaskIndex(): (data: getTaskDataType) => number | undefined;
  getLabels(state: State): Array<Label>;
  getLabel(state: State): (labelId: ID) => Label | undefined;
  getCommentIndex(): (data: getCommentDataType) => number | undefined;
  getDateEvents(state: State): (data: getDateEventsType) => Array<[]>;
  getMonthConstellation(state: State): (month: number) => string;
  getCalendarDays(state: State): (month: number) => Array<DayType>;
};

export const getters: GetterTree<State, State> & Getters = {
  loginDialogStatus: (state) => {
    return state.isOpenLoginDialog;
  },

  getChecklistStatus: (state) => {
    return state.isOpenLoginDialog;
  },

  addTaskDialogName: (state) => {
    return state.addTaskDialogName;
  },

  googleToken: (state) => {
    return state.googleToken;
  },

  getColumns: (state) => {
    return state.columns;
  },

  getColumn: (state) => (columnId: ID) => {
    const column = state.columns.find((column) => column.id === columnId);
    return column;
  },

  getColumnGetter: (state) => {
    // if (state.searchText) {
    //   const searchedData: any[] = [];
    //   for (let index = 0; index < state.columns.length; index++) {
    //     searchedData[index] = state.columns[index];
    //     searchedData[index].tasks = [];
    //     for (
    //       let taskIndex = 0;
    //       taskIndex < state.columns[index].tasks.length;
    //       taskIndex++
    //     ) {
    //       if (
    //         state.columns[index].tasks[taskIndex].title.includes(
    //           state.searchText
    //         )
    //       ) {
    //         searchedData[index].tasks.push(
    //           state.columns[index].tasks[taskIndex]
    //         );
    //       }
    //     }
    //   }
    //
    //   console.log({ searchedData });
    //   return searchedData;
    // }
    return state.columns;
  },

  getColumnIndex: (state) => (columnId: ID) => {
    const column = state.columns.findIndex((column) => column.id === columnId);
    return column;
  },

  getTask: () => (data) => {
    const taskData = data.column?.tasks.find((task) => task.id === data.taskId);
    return taskData;
  },

  getTaskIndex: () => (data) => {
    const taskIndex = data.column?.tasks.findIndex(
      (task) => task.id === data.taskId
    );
    return taskIndex;
  },

  getLabels: (state) => {
    return state.labels;
  },

  getLabel: (state) => (labelId: ID) => {
    const label = state.labels.find((label) => label && label.id === labelId);
    return label;
  },

  getCommentIndex: () => (data) => {
    const commentIndex = data.task?.comments.findIndex(
      (comment) => comment.id === data.commentId
    );
    return commentIndex;
  },

  getCheckList: (state) => {
    return state.checkList;
  },

  getUserName: (state) => {
    if (!state.userInfo) return "";
    return state.userInfo.name;
  },

  getUserPicture: (state) => {
    if (!state.userInfo) return "";
    return state.userInfo.picture;
  },

  getDateEvents:
    (state) =>
    ({ shDay, mlDay, hjDay }) => {
      const dateTime = new DateTime(new Date());
      let events: any = [];
      state.calendar.calendarObject?.forEach(
        (month: Array<[]>, monthIndex: number) => {
          month.forEach((day: any) => {
            if (
              day[0] === shDay &&
              day[1] === mlDay &&
              parseInt(dateTime.getShMonthEn()) === monthIndex + 1
            ) {
              events = day[4];
            }
          });
        }
      );
      return events;
    },

  getMonthConstellation:
    (state) =>
    (month = 1) => {
      return state.calendar.constellations[month - 1];
    },

  getCalendarDays: (state) => (month) => {
    return state.calendar.calendarObject[month - 1];
  },
};
